<template>
    <div class="right_float">
        <el-popover
            placement="left"
            trigger="hover"
            v-if="contactList.length > 0"
        >
            <div class="pop_con">
                <h3 class="pop_tit">您好，咨询请联系</h3>
                <p v-for="item in contactList" :key="item.id">
                    {{ item.deptName }}：{{ item.phoneNum }}
                </p>
            </div>
            <div class="phone" slot="reference">
                <i class="iconfont icon-dianhua"></i>
                <p class="text">
                    联系
                    <br />电话
                </p>
            </div>
        </el-popover>
        <el-backtop :visibility-height="300">
            <i class="iconfont icon-fanhuidingbu"></i>
        </el-backtop>
    </div>
</template>

<script>
export default {
    props: {
        contactList: {
            type: Array,
            default: () => {
                return [];
            },
            required: true,
        },
    },
    data() {
        return {};
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
.right_float {
    position: fixed;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    width: 36px;
    height: 118px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    z-index: 11;
    .phone {
        height: 66px;
        width: 36px;
        border-radius: 2px;
        background-color: #a13838;
        color: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        .text {
            font-size: 12px;
            margin-top: 5px;
            line-height: 1.2;
        }
    }

    ::v-deep .el-backtop {
        background-color: transparent;
        box-shadow: none;
        position: unset;
        height: 36px;
        width: 36px;
        border-radius: 2px;
        background-color: #a13838;
        color: #fff;
        font-size: 16px;
    }
}
.pop_con {
    width: 250px;
    .pop_tit {
        color: #333;
        font-size: 16px;
        font-weight: bold;
        padding-bottom: 10px;
    }
    p {
        margin-top: 5px;
        font-size: 12px;
    }
}
</style>
